import { Component, ViewChild } from '@angular/core';
import { NgbTabset } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-processo-tabset',
  templateUrl: './processo-tabset.component.html',
  styleUrls: ['./processo-tabset.component.css']
})
export class ProcessoTabsetComponent {
  @ViewChild('tabset', { read: NgbTabset, }) tabset: NgbTabset;

  constructor() {
  }

  voltar(): void {
    if (this.tabset) {
      this.tabset.select('processo');
    }
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/processo/processo-tabset/processo-tabset.component.ts